import {
  DocumentUrl,
  Files,
} from "./supplierSettlement/supplierSettlement.model";

export class GetChequesRequest {
  referenceKey: string | undefined;
  chequeType: string | undefined;
}
export interface ChequesResponse {
  referenceKey: string | undefined;
  chequeId: number | undefined;
  chequeType: string | undefined;
  amount?: number | undefined;
  dueDate: Date | undefined;
  dueDatePersian: string | undefined;
  fileId: string | undefined;
  sayadNumber: string | undefined;
  signer: string | undefined;
  serialNo: string | undefined;
  seriesNo: string | undefined;
  fromIban: string | undefined;
  branchCode: string | undefined;
  expectedHolder: string | undefined;
  expectedIdCode: string | undefined;
  file: DocumentUrl | undefined;
  isAccumulative: boolean;
  accumulativeAmount: number;
  inquiryAmount: number;
  inquiryDueDatePersian: string | undefined;
  inquiryDueDate: Date | undefined;
  bankName: string | undefined;
  bankCode: string | undefined;
  rearFile: DocumentUrl | undefined;
  reasonCode: string | undefined;
  reasonTitle: string | undefined;
}
export class AddChequeRequest {
  sayadNumber: string | undefined;
  chequeType: string | undefined;
  chequeId: number | undefined;
  file?: File | undefined;
  referenceKey: string | undefined;
}
export class DeleteChequesRequest {
  referenceKey: string | undefined;
  chequeId: number | undefined;
  sayadNumber: string | undefined;
}
export class ValidateChequeRequest {
  referenceKey: string | undefined;
  registrationLoanId: number | undefined;
  sayadNumber: string | undefined;
  chequeType: string | undefined;
  chequeId: number | undefined;
}
export interface ValidateChequeResponse {
  isValid?: boolean;
  validationIssues: string[];
  sayadChequeInquiryResponse: SayadChequeInquiryResponse;
  accumulativeAmount: number;
  inquiryAmount: number;
  isAccumulative: boolean;
  dueDatePersian: string;
  inquiryDueDatePersian: string;
  dueDate: Date;
  inquiryDueDate: Date;
}

export interface SayadChequeInquiryResponse {
  message: string;
  referenceId: string;
  sayadId: string;
  branchCode: string;
  bankCode: string;
  amount: number;
  dueDate: string;
  description: string;
  serialNo: string;
  seriesNo: string;
  fromIban: string;
  reason: string;
  currency: number;
  chequeStatus: number;
  chequeType: number;
  chequeMedia: number;
  blockStatus: number;
  guaranteeStatus: number;
  locked: number;
  holders: Holders[];
  signers: Signers[];
  lockerBankCode: string;
  lockerBranchCode: string;
  issueDate: string;
  toIban: string;
  isSuccess: boolean;
}
export interface Holders {
  idCode: string;
  idType: number;
  name: string;
}
export interface Signers {
  name: string;
  legalStamp: number;
}
